import { graphql } from 'gql.tada';
import { LinkBlockFragment } from '../blocks/link-block';
/**
 * GraphQL fragment for BannerPromo.
 * Fetches active promotional banners with icon, label text and CTA link.
 */
export const BannerPromoFragment = graphql(
/* GraphQL */ `
    fragment BannerPromoFragment on BannerPromoRecord {
      ... on RecordInterface {
        id
        __typename
      }
      isActive
      startDate
      endDate
      iconaAndLabel {
        icon
        text
      }
      cta {
        ...LinkBlockFragment
      }
    }
  `, [LinkBlockFragment]);
//# sourceMappingURL=banner-promo.js.map